/**
 * @generated SignedSource<<600f249b6150b2ccef97c67793fc3512>>
 * @relayHash 3e8398ac4cc35cda2ed93f4628fc8a69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePolicyEnabledStatus = "DISABLED" | "ENABLED" | "UNDETERMINED_DUE_TO_INTERNAL_ERROR" | "%future added value";
export type useDataRetentionDetailsQuery$variables = {
  cloudId: string;
};
export type useDataRetentionDetailsQuery$data = {
  readonly confluence_dataLifecycleManagementPolicy: {
    readonly dataRetentionPolicyDetailsForWorkspace: {
      readonly disabledOnDate: {
        readonly value: string;
      } | null;
      readonly policyEnabledStatus: ConfluencePolicyEnabledStatus;
    };
  } | null;
};
export type useDataRetentionDetailsQuery = {
  response: useDataRetentionDetailsQuery$data;
  variables: useDataRetentionDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceDataLifecycleManagementPolicy",
    "kind": "LinkedField",
    "name": "confluence_dataLifecycleManagementPolicy",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceDataRetentionPolicyStatus",
        "kind": "LinkedField",
        "name": "dataRetentionPolicyDetailsForWorkspace",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "policyEnabledStatus"
          },
          {
            "concreteType": "ConfluenceDate",
            "kind": "LinkedField",
            "name": "disabledOnDate",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useDataRetentionDetailsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDataRetentionDetailsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3e8398ac4cc35cda2ed93f4628fc8a69",
    "id": "011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd",
    "metadata": {},
    "name": "useDataRetentionDetailsQuery",
    "operationKind": "query",
    "text": "query useDataRetentionDetailsQuery($cloudId:ID!){confluence_dataLifecycleManagementPolicy(cloudId:$cloudId){dataRetentionPolicyDetailsForWorkspace{policyEnabledStatus,disabledOnDate{value}}}}"
  }
};
})();

(node as any).hash = "0241f940fae6659cf9e57c7aaae37fa7";

export default node;
